import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { TipiDannoComponent } from 'src/app/anagrafiche/tipi-danno/tipi-danno.component';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Model } from 'src/app/models/model';
import { takeUntil } from 'rxjs/operators';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => TipoDannoPickerComponent) },
  ],
  selector: 'tipo-danno-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class TipoDannoPickerComponent extends ExternalSelectorComponent {

  @Input() multipleSelection = false;
  onChange: any;

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog
      .open(TipiDannoComponent, { data: { selectionMode: !this.multipleSelection, multipleSelection: this.multipleSelection, showReset: true } })
      .afterClosed();
  };

  parts: FormGroup = this.fb.group({
    humanIdentifier: [''],
    id: [''],
  });

  query: FormGroup = this.fb.group({
    states: new FormArray([])
  });

  registerOnChange(onChange: (value: Model | null) => void): void {
    if (this.multipleSelection) {
      this.query.valueChanges.pipe(
        takeUntil(this.destroy),
      ).subscribe((value) => {
        if (value.states) onChange(value.states);
      });
    } else {
      this.parts.valueChanges.pipe(
        takeUntil(this.destroy),
      ).subscribe((value) => {
        if (value.id) {
          onChange(value);
        } else {
          onChange(null);
        }
      });
    }
  }

  public writeValue(value?: any): any {
    if (value === null || value === undefined) {
      this.parts.reset();
      const statesArray = this.query.get('states') as FormArray;
      statesArray.clear();
      this.stateChanges.next();
    }
    else if (this.multipleSelection) {
      const states = new FormArray(value.map(item => new FormControl(item.id)));

      this.parts.patchValue({
        humanIdentifier: value.map(item => item.humanIdentifier || item.nome).join(', '),
        id: value.map(item => item.id)
      });

      this.query.setControl('states', states);
      this.stateChanges.next();
    } else {
      if (value && typeof value === 'object') {
        this.parts.patchValue({
          humanIdentifier: value.humanIdentifier || value.nome || '',
          id: value.id
        });
      } else {
        this.parts.patchValue({
          humanIdentifier: '',
          id: value
        });
      }
      this.stateChanges.next();
    }
  }


}
